import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  isButtonLoading: false,
  blogs: [],
};

export const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setButtonLoading: (state, action) => {
      state.isButtonLoading = action.payload;
    },
    setBlogs: (state, action) => {
      state.blogs = action.payload;
    },
  },
});

export const { setLoading, setButtonLoading, setBlogs } = blogSlice.actions;

export default blogSlice.reducer;
